import React, { Children, isValidElement } from "react";
import ColorPicker from "../ColorPicker/ColorPicker";

const ehColorPicker = (item: React.ReactNode) => isValidElement(item) && item.type === ColorPicker;

export const agruparColorPickers = (children: React.ReactNode) => {
    const itens = Children.toArray(children);

    if (!itens.some(ehColorPicker)) return children;

    const saida: React.ReactNode[] = [];
    let cores: React.ReactNode[] = [];

    const fechar = () => {
        if (!cores.length) return;

        saida.push(<div key={`cores-${saida.length}`}>{cores}</div>);
        cores = [];
    };

    for (const item of itens) {
        if (ehColorPicker(item)) {
            cores.push(item);
            continue;
        }

        fechar();
        saida.push(item);
    }

    fechar();

    return saida;
};
